import React, { useEffect, useState } from 'react'
import GlobalStyles from '../assets/styles/GlobalStyles'
import Counter from '../components/section/counter'
import Layout from '../common/layout'
import NotFoundBanner from '../components/section/banner/notFound'

const NotFound = () => {
  return (
    <>
      <Layout>
        <GlobalStyles />
        <NotFoundBanner />
      </Layout>
    </>
  )
}

export default NotFound